import React, { Component } from 'react';
import './AppList.css';
import * as BlurImage from '../assets/BlurImage.js';
class AppList extends Component {

  componentDidMount () {
    let bgs = document.querySelectorAll(".app_item_bg");
    /*bgs.forEach((bgItem) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => BlurImage.stackBlurImage(img, bgItem, 46, false);
      img.src = this.props.apps[parseInt(bgItem.id.substr("canvasBg".length))].appBg;
    });*/
    for (let i = 0; i < bgs.length; i++) {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => BlurImage.stackBlurImage(img, bgs[i], 46, false);
      img.src = this.props.apps[parseInt(bgs[i].id.substr("canvasBg".length))].appBg;
    }
  }

  render() {
    return (
      <div className="app_list" onClick={this.props.onClick}>
        {this.props.apps.map(
          (app, i) => {
            return (
              <div
                key={i}
                className={
                  this.props.apps.length % 2 !== 0 &&
                  i === this.props.apps.length - 1
                    ? "app_item_banner"
                    : "app_item"
                }
              >
                <a className="anchor" href="###" id={"app" + i}>
                  {" "}
                </a>
                <canvas id={"canvasBg" + i} className="app_item_bg" />
                <div className="app_item_box">
                  <div className="app_name">{app.appName}</div>
                  <img
                    src={app.appIcon}
                    className="app_icon"
                    alt={app.appName}
                  />
                  <div className="app_link">
                    {app.appLinkA ? (
                      <a
                        href={app.appLinkA}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("../assets/app_badge_apple.png")}
                          alt="AppStore"
                        />
                      </a>
                    ) : null}
                    {app.appLinkG ? (
                      <a
                        href={app.appLinkG}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("../assets/app_badge_google.png")}
                          alt="GooglePlay"
                        />
                      </a>
                    ) : null}
                    {app.appLinkR ? (
                      <a
                        href={app.appLinkR}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("../assets/app_badge_roblox.png")}
                          alt="Roblox"
                        />
                      </a>
                    ) : null}
                    {app.appLinkXR ? (
                      <a
                        href={app.appLinkXR}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("../assets/app_badge_xros.png")}
                          alt="visionOS Store"
                        />
                      </a>
                    ) : null}
                  </div>
                  <div
                    className={
                      app.appCat.length > 5 ? "app_cat app_cat_ext" : "app_cat"
                    }
                  >
                    {app.appCat}
                  </div>
                </div>
              </div>
            );
          }
        )}
      </div>
    );
  }
}

export default AppList;


